<button (click)="onClose()" class="ft-btn-close"></button>
<div class="ft2-page-overlay d-flex">
    <div class="ft2-container -full">
        <div class="row full-height">
            <div class="ft2-audience-onboard-bg col-3 d-md-none">
            </div>
            <div class="col-8 col-md-12 py-9 py-md-7 py-xs-4">
                <div class="ft2-container -narrow ml-0 px-0">
                    <ng-container *ngIf="!isUploadComplete">
                        <swiper-container #swiper ftSwiper [config]="swiperConfig" init="false"
                                          (swiperslidechange)="onSlideChange($event)">
                            <swiper-slide>
                                <div class="text-content px-8 px-lg-4 px-md-0">
                                    <h3>Let's get aligned with your transactions history.</h3>
                                    <p>
                                        Syncing your transactions establishes a solid baseline for your platform,
                                        giving you better visibility into period-over-period trends and historical
                                        pacing, as well as ensuring you can set the right goal posts based on
                                        accurate information.
                                    </p>
                                </div>
                            </swiper-slide>
                            <swiper-slide>
                                <div class="text-content px-8 px-lg-4 px-md-0">
                                    <h3>What we need.</h3>
                                    <p>
                                        Prepare a CSV with the following columns:
                                    </p>
                                    <p>
                                        <b>Required:</b> transaction_datetime (ISO 8601), crs_number, company_code, amount (numeric), currency (ISO 4217), arrival_date (ISO 8601), departure_date (ISO 8601).
                                        <br>
                                        <b>Optional:</b> adults (numeric), children (numeric).
                                    </p>
                                    <p>
                                        Your file should not exceed 10MB.
                                    </p>
                                    <p>
                                        You can safely sync your transaction records as many times as you need.
                                        If the same <b>crs_number</b> appears again in a future sync, it will
                                        update the existing record instead of duplicating it.
                                    </p>
                                </div>
                            </swiper-slide>
                            <swiper-slide>
                                <div class="px-8 px-lg-4 px-md-0">
                                    <div class="text-content">
                                        <h3>Ok, let's get your records updated.</h3>
                                    </div>
                                    <ft-dropzone-uploader [multiple]="false"
                                            [accept]="'.csv'"
                                            [label]="'Upload your file'"
                                            (selected)="onFilesSelected($event)" />
                                    <p class="mt-2 text-muted text-small">
                                        .csv &middot; 10MB limit per file
                                    </p>
                                    <div class="ft2-form-error" *ngIf="headerValidationError">
                                        {{ headerValidationError }}
                                    </div>
                                    <div class="ft2-form-error" *ngIf="error">
                                        {{ error.message }}
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper-container>
                        <div class="swiper-navigation h-between v-center pl-8 pl-lg-4 pl-md-3">
                            <div class="swiper-pagination">
                                <span *ngFor="let i of slides"
                                      class="swiper-pagination-rectangle"
                                      [class.swiper-pagination-rectangle-active]="i === slideIndex"
                                      (click)="goToSlide(i)"></span>
                            </div>
                            <div [hidden]="totalSlides === slideIndex + 1" (click)="nextSlide()">
                                <button class="swiper-button-circle">
                                    <mat-icon class="icon-md" svgIcon="arrow-right" />
                                </button>
                            </div>
                            <button class="ft2-btn-dark -outline -large"
                                    [ftLoading]="loading$"
                                    (click)="submit()"
                                    [disabled]="!files.length || !!headerValidationError"
                                    *ngIf="totalSlides === slideIndex + 1">
                                Submit
                            </button>
                        </div>
                    </ng-container>
                    <div *ngIf="isUploadComplete" class="ft2-audience-onboard-complete">
                        <div class="text-content px-8 px-lg-4 px-md-0">
                            <h3>Upload complete.</h3>
                            <p>
                                Imported: <b>{{ result?.rowsImported }}</b>
                                &nbsp;·&nbsp; Rejected: <b>{{ result?.rowsRejected }}</b>
                            </p>
                            <div *ngIf="result?.errors?.length" class="mt-3">
                                <h5>Rejected rows</h5>
                                <ul class="transactions-import-errors">
                                    <li *ngFor="let e of result.errors">
                                        Row {{ e.rowNumber }}: {{ e.message }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="h-end">
                            <button class="ft2-btn-dark -outline -large" (click)="onClose()">Return to your account</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
